<app-course-catalogue-details-card id="included" i18n-label label="Included">
  <div class="flex flex-col gap-5">
    <div>
      <h3 class="font-bold" i18n>We provide:</h3>
      <ul>
        @for (item of weProvideItems; track $index) {
          <li class="list-item list-disc list-inside text-primary">
            <span class="text-slate-700">{{ item.title }}</span>
          </li>
        }
      </ul>
    </div>

    <div>
      <h3 class="font-bold" i18n>You provide:</h3>
      <ul>
        @for (item of youProvideItems; track $index) {
          <li class="list-item list-disc list-inside text-primary">
            <span class="text-slate-700">{{ item.title }}</span>
          </li>
        }
      </ul>
    </div>

    <p i18n>Please sign everything.</p>
  </div>
</app-course-catalogue-details-card>
